import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeUriText'
})
export class EncodeUriTextPipe implements PipeTransform {
  transform(value: string): any {
    return encodeURIComponent(value);
  }
}
